<template>
  <div class="page">
    <div class="page__bd">
      <div class="form-preview weui-form-preview">
        <div class="weui-form-preview__hd">
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">单据编号</label>
            <em class="weui-form-preview__value">{{ form.main.wg_code }}</em>
          </div>
        </div>
        <custom-layout class="weui-form-preview__bd" :view-config="customViewConfig">
          <div class="weui-form-preview__item" slot="wg_yearmonth">
            <label class="weui-form-preview__label">{{customLabel.wg_yearmonth || "年月"}}</label>
            <span class="weui-form-preview__value">{{
              form.main.wg_yearmonth
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="wg_reissue">
            <label class="weui-form-preview__label">{{customLabel.wg_reissue || "补发"}}</label>
            <span class="weui-form-preview__value"
              >{{ numberFormat(form.main.wg_reissue,'#,##0.00') }}
              </span>
          </div>
          <div class="weui-form-preview__item" slot="wg_wage">
            <label class="weui-form-preview__label">{{customLabel.wg_wage || "应发工资"}}</label>
            <span
              class="weui-form-preview__value weui-form-preview__value-icon"
              >{{ numberFormat(form.main.wg_wage,'#,##0.00') }}
            </span>
          </div>
          <div class="weui-form-preview__item" slot="wg_commission">
            <label class="weui-form-preview__label">{{customLabel.wg_commission || "业绩提成"}}</label>
            <span class="weui-form-preview__value"
              >{{ numberFormat(form.main.wg_commission,'#,##0.00') }}
              </span>
          </div>
          <div class="weui-form-preview__item" slot="wg_reward">
            <label class="weui-form-preview__label">{{customLabel.wg_reward || "奖励"}}</label>
            <span class="weui-form-preview__value"
              >{{ numberFormat(form.main.wg_reward,'#,##0.00') }}
              </span>
          </div>
          <div class="weui-form-preview__item" slot="wg_otheryf">
            <label class="weui-form-preview__label">{{customLabel.wg_otheryf || "其他应发"}}</label>
            <span class="weui-form-preview__value"
              >{{ numberFormat(form.main.wg_otheryf,'#,##0.00') }}
              </span>
          </div>
          <div class="weui-form-preview__item" slot="wg_actwage">
            <label class="weui-form-preview__label">{{customLabel.wg_actwage || "实发工资"}}</label>
            <span class="weui-form-preview__value"
              >{{ numberFormat(form.main.wg_actwage,'#,##0.00') }}
              </span>
          </div>
          <div class="weui-form-preview__item" slot="wg_yfwage">
            <label class="weui-form-preview__label">{{customLabel.wg_yfwage || "已发工资"}}</label>
            <span class="weui-form-preview__value"
              >{{ numberFormat(form.main.wg_yfwage,'#,##0.00') }}
              </span>
          </div>
        </custom-layout>
        <custom-layout class="weui-form-preview__bd" :view-config="customViewConfig">
          <div class="weui-form-preview__item" slot="wg_basewage">
            <label class="weui-form-preview__label">{{customLabel.wg_basewage || "基本工资"}}</label>
            <span class="weui-form-preview__value">
              {{ numberFormat(form.main.wg_basewage,'#,##0.00') }}
            </span>
          </div>
          <div class="weui-form-preview__item" slot="wg_postwage">
            <label class="weui-form-preview__label">{{customLabel.wg_postwage || "岗位工资"}}</label>
            <span class="weui-form-preview__value"
              >{{ numberFormat(form.main.wg_postwage,'#,##0.00') }}
              </span>
          </div>
          <div class="weui-form-preview__item" slot="wg_meritwage">
            <label class="weui-form-preview__label">{{customLabel.wg_meritwage || "绩效工资"}}</label>
            <span
              class="weui-form-preview__value weui-form-preview__value-icon"
              >{{ numberFormat(form.main.wg_meritwage,'#,##0.00') }}
            </span>
          </div>
          <div class="weui-form-preview__item" slot="wg_piecewage">
            <label class="weui-form-preview__label">{{customLabel.wg_piecewage || "计件工资"}}</label>
            <span class="weui-form-preview__value"
              >{{ numberFormat(form.main.wg_piecewage,'#,##0.00') }}
              </span>
          </div>
          <div class="weui-form-preview__item" slot="wg_senioritywage">
            <label class="weui-form-preview__label">{{customLabel.wg_senioritywage || "工龄工资"}}</label>
            <span class="weui-form-preview__value"
              >{{ numberFormat(form.main.wg_senioritywage,'#,##0.00') }}
              </span>
          </div>
          <div class="weui-form-preview__item" slot="wg_quanqinwage">
            <label class="weui-form-preview__label">{{customLabel.wg_quanqinwage || "全勤奖金"}}</label>
            <span class="weui-form-preview__value"
              >{{ numberFormat(form.main.wg_quanqinwage,'#,##0.00') }}
              </span>
          </div>
          <div class="weui-form-preview__item" slot="wg_subsidy">
            <label class="weui-form-preview__label">{{customLabel.wg_subsidy || "补助"}}</label>
            <span class="weui-form-preview__value"
              >{{ numberFormat(form.main.wg_subsidy,'#,##0.00') }}
              </span>
          </div>
          <div class="weui-form-preview__item" slot="wg_otherwage">
            <label class="weui-form-preview__label">{{customLabel.wg_otherwage || "其他"}}</label>
            <span class="weui-form-preview__value"
              >{{ numberFormat(form.main.wg_otherwage,'#,##0.00') }}
              </span>
          </div>
        </custom-layout>
        <custom-layout class="weui-form-preview__bd" :view-config="customViewConfig">
          <div class="weui-form-preview__item" slot="wg_shebaogr">
            <label class="weui-form-preview__label">{{customLabel.wg_shebaogr || "社保(个人)"}}</label>
            <span class="weui-form-preview__value">
              {{ numberFormat(form.main.wg_shebaogr,'#,##0.00') }}
            </span>
          </div>
          <div class="weui-form-preview__item" slot="wg_shebaogs">
            <label class="weui-form-preview__label">{{customLabel.wg_shebaogs || "社保(公司)"}}</label>
            <span class="weui-form-preview__value"
              >{{ numberFormat(form.main.wg_shebaogs,'#,##0.00') }}
              </span>
          </div>
          <div class="weui-form-preview__item" slot="wg_gongjijingr">
            <label class="weui-form-preview__label">{{customLabel.wg_gongjijingr || "公积金(个人)"}}</label>
            <span
              class="weui-form-preview__value weui-form-preview__value-icon"
              >{{ numberFormat(form.main.wg_gongjijingr,'#,##0.00') }}
            </span>
          </div>
          <div class="weui-form-preview__item" slot="wg_gongjijings">
            <label class="weui-form-preview__label">{{customLabel.wg_gongjijings || "公积金(公司)"}}</label>
            <span class="weui-form-preview__value"
              >{{ numberFormat(form.main.wg_gongjijings,'#,##0.00') }}
              </span>
          </div>
          <div class="weui-form-preview__item" slot="wg_nianjingr">
            <label class="weui-form-preview__label">{{customLabel.wg_nianjingr || "年金(个人)"}}</label>
            <span class="weui-form-preview__value"
              >{{ numberFormat(form.main.wg_nianjingr,'#,##0.00') }}
              </span>
          </div>
          <div class="weui-form-preview__item" slot="wg_nianjings">
            <label class="weui-form-preview__label">{{customLabel.wg_nianjings || "年金(公司)"}}</label>
            <span class="weui-form-preview__value"
              >{{ numberFormat(form.main.wg_nianjings,'#,##0.00') }}
              </span>
          </div>
          <div class="weui-form-preview__item" slot="wg_geshui">
            <label class="weui-form-preview__label">{{customLabel.wg_geshui || "个税"}}</label>
            <span class="weui-form-preview__value"
              >{{ numberFormat(form.main.wg_geshui,'#,##0.00') }}
              </span>
          </div>
          <div class="weui-form-preview__item" slot="wg_qita">
            <label class="weui-form-preview__label">{{customLabel.wg_qita || "其他"}}</label>
            <span class="weui-form-preview__value"
              >{{ numberFormat(form.main.wg_qita,'#,##0.00') }}
              </span>
          </div>
        </custom-layout>
      </div>
      <div class="form-preview weui-form-preview">
        <div
          class="weui-form-preview__bd form-detail-preview"
          v-for="(item, index) in form.items"
          :key="item.id"
        >
          <div class="form-detail-preview_num">{{ index }}</div>
          <custom-layout :view-config="customViewConfig" position="detail1">
            <div class="weui-form-preview__item" slot="wd_emcode">
              <label class="weui-form-preview__label">{{customLabel.wd_emcode || "工号"}}</label>
              <span class="weui-form-preview__value weui-form-preview__value-icon"
                >{{ item.wd_emcode }}
              </span>
            </div>
            <div class="weui-form-preview__item" slot="wd_emname">
              <label class="weui-form-preview__label">{{customLabel.wd_emname || "姓名"}}</label>
              <span class="weui-form-preview__value weui-form-preview__value-icon"
                >{{ item.wd_emname }}
              </span>
            </div>
            <div class="weui-form-preview__item" slot="wd_depart">
              <label class="weui-form-preview__label">{{customLabel.wd_depart || "部门"}}</label>
              <span class="weui-form-preview__value weui-form-preview__value-icon"
                >{{ item.wd_depart }}
              </span>
            </div>
            <template v-if="index == showIndex">
              <div class="weui-form-preview__item" slot="wd_basewage">
                <label class="weui-form-preview__label">{{customLabel.wd_basewage || "基本工资"}}</label>
                <span class="weui-form-preview__value weui-form-preview__value-icon"
                  >{{ numberFormat(item.wd_basewage,'#,##0.00') }}
                </span>
              </div>
              <div class="weui-form-preview__item" slot="wd_postwage">
                <label class="weui-form-preview__label">{{customLabel.wd_postwage || "岗位工资"}}</label>
                <span class="weui-form-preview__value weui-form-preview__value-icon"
                  >{{ numberFormat(item.wd_postwage,'#,##0.00') }}
                </span>
              </div>
              <div class="weui-form-preview__item" slot="wd_meritwage">
                <label class="weui-form-preview__label">{{customLabel.wd_meritwage || "绩效工资"}}</label>
                <span class="weui-form-preview__value weui-form-preview__value-icon"
                  >{{ numberFormat(item.wd_meritwage,'#,##0.00') }}
                </span>
              </div>
              <div class="weui-form-preview__item" slot="wd_piecewage">
                <label class="weui-form-preview__label">{{customLabel.wd_piecewage || "计件工资"}}</label>
                <span class="weui-form-preview__value weui-form-preview__value-icon"
                  >{{ numberFormat(item.wd_piecewage,'#,##0.00') }}
                </span>
              </div>
              <div class="weui-form-preview__item" slot="wd_senioritywage">
                <label class="weui-form-preview__label">{{customLabel.wd_senioritywage || "工龄工资"}}</label>
                <span class="weui-form-preview__value weui-form-preview__value-icon"
                  >{{ numberFormat(item.wd_senioritywage,'#,##0.00') }}
                </span>
              </div>
              <div class="weui-form-preview__item" slot="wd_subsidy">
                <label class="weui-form-preview__label">{{customLabel.wd_subsidy || "补助"}}</label>
                <span class="weui-form-preview__value weui-form-preview__value-icon"
                  >{{ numberFormat(item.wd_subsidy,'#,##0.00') }}
                </span>
              </div>
              <div class="weui-form-preview__item" slot="wd_otherwage">
                <label class="weui-form-preview__label">{{customLabel.wd_otherwage || "其他"}}</label>
                <span class="weui-form-preview__value weui-form-preview__value-icon"
                  >{{ numberFormat(item.wd_otherwage,'#,##0.00') }}
                </span>
              </div>
              <div class="weui-form-preview__item" slot="wd_reissue">
                <label class="weui-form-preview__label">{{customLabel.wd_reissue || "补发"}}</label>
                <span class="weui-form-preview__value weui-form-preview__value-icon"
                  >{{ numberFormat(item.wd_reissue,'#,##0.00') }}
                </span>
              </div>
              <div class="weui-form-preview__item" slot="wd_wage">
                <label class="weui-form-preview__label">{{customLabel.wd_wage || "合计"}}</label>
                <span class="weui-form-preview__value weui-form-preview__value-icon"
                  >{{ numberFormat(item.wd_wage,'#,##0.00') }}
                </span>
              </div>
              <div class="weui-form-preview__item" slot="wd_commission">
                <label class="weui-form-preview__label">{{customLabel.wd_commission || "业绩提成"}}</label>
                <span class="weui-form-preview__value weui-form-preview__value-icon"
                  >{{ numberFormat(item.wd_commission,'#,##0.00') }}
                </span>
              </div>
              <div class="weui-form-preview__item" slot="wd_reward">
                <label class="weui-form-preview__label">{{customLabel.wd_reward || "奖励"}}</label>
                <span class="weui-form-preview__value weui-form-preview__value-icon"
                  >{{ numberFormat(item.wd_reward,'#,##0.00') }}
                </span>
              </div>
              <div class="weui-form-preview__item" slot="wd_otheryf">
                <label class="weui-form-preview__label">{{customLabel.wd_otheryf || "其他应发"}}</label>
                <span class="weui-form-preview__value weui-form-preview__value-icon"
                  >{{ numberFormat(item.wd_otheryf,'#,##0.00') }}
                </span>
              </div>
              <div class="weui-form-preview__item" slot="wd_quanqinwage">
                <label class="weui-form-preview__label">{{customLabel.wd_quanqinwage || "全勤奖金"}}</label>
                <span class="weui-form-preview__value weui-form-preview__value-icon"
                  >{{ numberFormat(item.wd_quanqinwage,'#,##0.00') }}
                </span>
              </div>
              <div class="weui-form-preview__item" slot="wd_overtimepay">
                <label class="weui-form-preview__label">{{customLabel.wd_overtimepay || "加班费"}}</label>
                <span class="weui-form-preview__value weui-form-preview__value-icon"
                  >{{ numberFormat(item.wd_overtimepay,'#,##0.00') }}
                </span>
              </div>
              <div class="weui-form-preview__item" slot="wd_late">
                <label class="weui-form-preview__label">{{customLabel.wd_late || "迟到"}}</label>
                <span class="weui-form-preview__value weui-form-preview__value-icon"
                  >{{ numberFormat(item.wd_late,'#,##0.00') }}
                </span>
              </div>
              <div class="weui-form-preview__item" slot="wd_absenteeism">
                <label class="weui-form-preview__label">{{customLabel.wd_absenteeism || "旷工"}}</label>
                <span class="weui-form-preview__value weui-form-preview__value-icon"
                  >{{ numberFormat(item.wd_absenteeism,'#,##0.00') }}
                </span>
              </div>
              <div class="weui-form-preview__item" slot="wd_leaveearly">
                <label class="weui-form-preview__label">{{customLabel.wd_leaveearly || "早退"}}</label>
                <span class="weui-form-preview__value weui-form-preview__value-icon"
                  >{{ numberFormat(item.wd_leaveearly,'#,##0.00') }}
                </span>
              </div>
              <div class="weui-form-preview__item" slot="wd_personalleave">
                <label class="weui-form-preview__label">{{customLabel.wd_personalleave || "事假"}}</label>
                <span class="weui-form-preview__value weui-form-preview__value-icon"
                  >{{ numberFormat(item.wd_personalleave,'#,##0.00') }}
                </span>
              </div>
              <div class="weui-form-preview__item" slot="wd_sickleave">
                <label class="weui-form-preview__label">{{customLabel.wd_sickleave || "病假"}}</label>
                <span class="weui-form-preview__value weui-form-preview__value-icon"
                  >{{ numberFormat(item.wd_sickleave,'#,##0.00') }}
                </span>
              </div>
              <div class="weui-form-preview__item" slot="wd_attendancecut">
                <label class="weui-form-preview__label">{{customLabel.wd_attendancecut || "考勤扣款"}}</label>
                <span class="weui-form-preview__value weui-form-preview__value-icon"
                  >{{ numberFormat(item.wd_attendancecut,'#,##0.00') }}
                </span>
              </div>
              <div class="weui-form-preview__item" slot="wd_othercut">
                <label class="weui-form-preview__label">{{customLabel.wd_othercut || "其他扣款"}}</label>
                <span class="weui-form-preview__value weui-form-preview__value-icon"
                  >{{ numberFormat(item.wd_othercut,'#,##0.00') }}
                </span>
              </div>
              <div class="weui-form-preview__item" slot="wd_yfwage">
                <label class="weui-form-preview__label">{{customLabel.wd_yfwage || "应发金额"}}</label>
                <span class="weui-form-preview__value weui-form-preview__value-icon"
                  >{{ numberFormat(item.wd_yfwage,'#,##0.00') }}
                </span>
              </div>
              <div class="weui-form-preview__item" slot="wd_shebao">
                <label class="weui-form-preview__label">{{customLabel.wd_shebao || "社保"}}</label>
                <span class="weui-form-preview__value weui-form-preview__value-icon"
                  >{{ numberFormat(item.wd_shebao,'#,##0.00') }}
                </span>
              </div>
              <div class="weui-form-preview__item" slot="wd_gongjijin">
                <label class="weui-form-preview__label">{{customLabel.wd_gongjijin || "公积金"}}</label>
                <span class="weui-form-preview__value weui-form-preview__value-icon"
                  >{{ numberFormat(item.wd_gongjijin,'#,##0.00') }}
                </span>
              </div>
              <div class="weui-form-preview__item" slot="wd_nianjin">
                <label class="weui-form-preview__label">{{customLabel.wd_nianjin || "年金"}}</label>
                <span class="weui-form-preview__value weui-form-preview__value-icon"
                  >{{ numberFormat(item.wd_nianjin,'#,##0.00') }}
                </span>
              </div>
              <div class="weui-form-preview__item" slot="wd_geshui">
                <label class="weui-form-preview__label">{{customLabel.wd_geshui || "个税"}}</label>
                <span class="weui-form-preview__value weui-form-preview__value-icon"
                  >{{ numberFormat(item.wd_geshui,'#,##0.00') }}
                </span>
              </div>
              <div class="weui-form-preview__item" slot="wd_qita">
                <label class="weui-form-preview__label">{{customLabel.wd_qita || "其他"}}</label>
                <span class="weui-form-preview__value weui-form-preview__value-icon"
                  >{{ numberFormat(item.wd_qita,'#,##0.00') }}
                </span>
              </div>
              <div class="weui-form-preview__item" slot="wd_actwage">
                <label class="weui-form-preview__label">{{customLabel.wd_actwage || "实发金额"}}</label>
                <span class="weui-form-preview__value weui-form-preview__value-icon"
                  >{{ numberFormat(item.wd_actwage,'#,##0.00') }}
                </span>
              </div>
            </template>
          </custom-layout>
          <div class="weui-form-preview__item" :key="index">
            <!-- <label class="weui-form-preview__label">{{"操作"}}</label> -->
            <span class="weui-form-preview__value weui-form-preview__value-icon">
              <i class="iconfont icon-shang" v-if="index == showIndex" @click="showIndex = -1"></i>
              <i class="iconfont icon-xia" v-else @click="showIndex = index"></i>
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CustomLayout from "@/components/layout/CustomLayout.vue";
import form from "@/mixins/form.js";

export default {
  components: {
    CustomLayout
  },
  mixins: [form],
  data() {
    return {
      baseUrl: "/api/hr/wage",
      showIndex: -1
    };
  }
}
</script>